const DEFAULT_TRANSITION_DURATION = {
  enter: 0,
  exit: 600
};
const TRIGGER_MESSAGE_ID = 'message_for_trigger';

export { DEFAULT_TRANSITION_DURATION as D, TRIGGER_MESSAGE_ID as T };
//# sourceMappingURL=constants-DsghXWMj.js.map
